import { render, staticRenderFns } from "./PageAddOrEdit.vue?vue&type=template&id=3dc6baf4"
import script from "./PageAddOrEdit.vue?vue&type=script&lang=js"
export * from "./PageAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./PageAddOrEdit.vue?vue&type=style&index=0&id=3dc6baf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports